import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInteractions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.698 7.764a.8.8 0 0 0-.934.932l2.571 7.84 1.611-3.543a2.04 2.04 0 0 1 1.043-1.043l3.557-1.616zm-1.775-.842a2.3 2.3 0 0 1 2.203-.596l8.012 2.623a1.392 1.392 0 0 1 .239 2.655l-3.78 1.718a.54.54 0 0 0-.28.279l-.004.009-1.713 3.767a1.393 1.393 0 0 1-2.667-.303l-2.607-7.95a2.3 2.3 0 0 1 .597-2.202M8.208 1.25a.75.75 0 0 1 .75.75v1.552a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75m4.92 2.038a.75.75 0 0 1 0 1.06l-1.1 1.1a.75.75 0 1 1-1.061-1.06l1.1-1.1a.75.75 0 0 1 1.06 0Zm-9.843.003a.75.75 0 0 1 1.06 0l1.1 1.1a.75.75 0 0 1-1.06 1.06l-1.1-1.1a.75.75 0 0 1 0-1.06M1.25 8.207a.75.75 0 0 1 .75-.75h1.552a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m4.195 2.763a.75.75 0 0 1 0 1.06l-1.1 1.1a.75.75 0 0 1-1.06-1.06l1.1-1.1a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInteractions;
